import { AstroTransitionLink } from "@components/AstroTransitionLink"
import type { SupportedLocale as Lang } from "@site-types/site"
import "./styles.css"

export function BackButton({ locale, page }: { locale: Lang; page: string }) {
  return (
    <AstroTransitionLink
      to={`/${locale}/${page}`}
      data-testid="back-button"
    >
      <i className="fa-sharp fa-regular fa-arrow-left" />
    </AstroTransitionLink>
  )
}

export default BackButton
